import React, { useState } from 'react'
import { Formik } from 'formik'
import get from 'lodash/get'
import * as Yup from 'yup'
import { t } from '../../i18n'

const FeederDosingModeForm = ({
  dosingMode = {
    name: '',
    dosing_para_fast: {
      id: null,
      pressure: 0,
      frequency: 0,
      duty_cycle: 0
    },
    dosing_para_slow: {
      id: null,
      pressure: 0,
      frequency: 0,
      duty_cycle: 0
    },
  },
  onSubmitForm
}) => {

  const validationSchema = Yup.object({
    name: Yup.string().required(t('feeder_dosing_modes.validations.name')),
    dosing_para_fast: Yup.object({
      pressure: Yup.number()
        .required(t('feeder_dosing_modes.validations.pressure.required'))
        .min(0.1, t('feeder_dosing_modes.validations.pressure.min', { min: 0.1 }))
        .max(6.0, t('feeder_dosing_modes.validations.pressure.max', { max: 6.0 })),
      frequency: Yup.number()
        .required(t('feeder_dosing_modes.validations.frequency.required'))
        .min(1.0, t('feeder_dosing_modes.validations.frequency.min', { min: 1.0 }))
        .max(25.0, t('feeder_dosing_modes.validations.frequency.max', { max: 25.0 })),
      duty_cycle: Yup.number()
        .required(t('feeder_dosing_modes.validations.duty_cycle.required'))
        .min(0, t('feeder_dosing_modes.validations.duty_cycle.min', { min: 0 }))
        .max(100, t('feeder_dosing_modes.validations.duty_cycle.max', { max: 100 })),
    }),
    dosing_para_slow: Yup.object({
      pressure: Yup.number()
        .required(t('feeder_dosing_modes.validations.pressure.required'))
        .min(0.1, t('feeder_dosing_modes.validations.pressure.min', { min: 0.1 }))
        .max(6.0, t('feeder_dosing_modes.validations.pressure.max', { max: 6.0 })),
      frequency: Yup.number()
        .required(t('feeder_dosing_modes.validations.frequency.required'))
        .min(1.0, t('feeder_dosing_modes.validations.frequency.min', { min: 1.0 }))
        .max(25.0, t('feeder_dosing_modes.validations.frequency.max', { max: 25.0 })),
      duty_cycle: Yup.number()
        .required(t('feeder_dosing_modes.validations.duty_cycle.required'))
        .min(0, t('feeder_dosing_modes.validations.duty_cycle.min', { min: 0 }))
        .max(100, t('feeder_dosing_modes.validations.duty_cycle.max', { max: 100 })),
    }),
  });

  return (
    <Formik
      initialValues={dosingMode}
      validationSchema={validationSchema}
      onSubmit={(values, { setStatus, setSubmitting }) => {
        const payload = { ...values }
        return onSubmitForm(payload, (success, errorData) => {
          let status = {}
          if (!success) {
            const fields = Object.getOwnPropertyNames(errorData.full_errors)
            for (let key in fields) {
              status[`${fields[key]}_error`] =
                errorData.full_errors[fields[key]].join(', ')
            }
          }
          setStatus(status)
          setSubmitting(false)
        })
      }}
    >
      {({
        values,
        errors,
        touched,
        status,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        setStatus,
      }) => {
        const enhancedHandleChange = (e) => {
          let newStatus = Object.assign({}, status)
          newStatus[`${e.target.name}_error`] = ''
          setStatus(newStatus)
          handleChange(e)
        }

        const renderField = (label, name, type, placeholder, value=null, inverted = true, autoComplete = 'off') => {
          const inputValue = value !== null ? value : values[name]
          const errorsPresent = get(errors, name) && get(touched, name) || (status && status[`${name}_error`])

          const errorMessage =
          typeof get(errors, name) === 'string'
            ? get(errors, name)
            : get(errors, name)?.required ||
              (status && status[`${name}_error`]);
          return (
            <div className="form-group">
              <label>{label}</label>
              <input
                id={name}
                name={name}
                type={type}
                onBlur={handleBlur}
                value={inputValue === null ? '' : inputValue}
                placeholder={placeholder}
                autoComplete={autoComplete}
                onChange={enhancedHandleChange}
                className={`form-control ${errorsPresent && 'is-invalid'} ${inverted && 'inverted'}`}
                step="any"
              />
              {errorsPresent && (
                <div className="invalid-feedback">
                   {errorMessage}
                </div>
              )}
            </div>
          )
        }


        return (
          <form onSubmit={handleSubmit} className="form-robis">
            {renderField(
              t('feeder_dosing_modes.name'),
              'name',
              'text',
              t('feeder_dosing_modes.enter_name')
            )}

            <div>
              <h5 style={{ margin: '40px 0 20px 10px' }}>Fast dosing mode</h5>
                <div
                  key='fast-dosing-mode'
                  className="dosing-mode-parameters"
                  style={{
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '20px',
                    marginBottom: '20px',
                  }}
                >
                  {renderField(
                    t('feeder_dosing_modes.pressure'),
                    'dosing_para_fast.pressure',
                    'number',
                    t('feeder_dosing_modes.enter_pressure'),
                    values.dosing_para_fast.pressure,
                    false
                  )}
                  {renderField(
                    t('feeder_dosing_modes.frequency'),
                    'dosing_para_fast.frequency',
                    'number',
                    t('feeder_dosing_modes.enter_frequency'),
                    values.dosing_para_fast.frequency,
                    false
                  )}
                  {renderField(
                    t('feeder_dosing_modes.duty_cycle'),
                    'dosing_para_fast.duty_cycle',
                    'number',
                    t('feeder_dosing_modes.enter_duty_cycle'),
                    values.dosing_para_fast.duty_cycle,
                    false
                  )}
                </div>
            </div>

            <div>
              <h5 style={{ margin: '40px 0 20px 10px' }}>Slow dosing mode</h5>
                <div
                  key='fast-dosing-mode'
                  className="dosing-mode-parameters"
                  style={{
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '20px',
                    marginBottom: '20px',
                  }}
                >
                  {renderField(
                    t('feeder_dosing_modes.pressure'),
                    'dosing_para_slow.pressure',
                    'number',
                    t('feeder_dosing_modes.enter_pressure'),
                    values.dosing_para_slow.pressure,
                    false
                  )}
                  {renderField(
                    t('feeder_dosing_modes.frequency'),
                    'dosing_para_slow.frequency',
                    'number',
                    t('feeder_dosing_modes.enter_frequency'),
                    values.dosing_para_slow.frequency,
                    false
                  )}
                  {renderField(
                    t('feeder_dosing_modes.duty_cycle'),
                    'dosing_para_slow.duty_cycle',
                    'number',
                    t('feeder_dosing_modes.enter_duty_cycle'),
                    values.dosing_para_slow.duty_cycle,
                    false
                  )}
                </div>
            </div>

            <div className="form-actions d-flex justify-content-end">
              <a className="btn btn-secondary inverted me-2" href="/admin/feeder_dosing_modes">
                {t('cancel')}
              </a>
              <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                {t('save')}
              </button>
            </div>
          </form>
        )
      }}
    </Formik>
  )
}

export default FeederDosingModeForm
